@optional @link fn getAlbedo() -> vec4<f32> { return vec4<f32>(1.0, 1.0, 1.0, 1.0); }
@optional @link fn getTexture(uv: vec2<f32>) -> vec4<f32> { return vec4<f32>(0.0); }

@export fn getColor(
  inColor: vec4<f32>,
  mapUV: vec4<f32>,
  mapST: vec4<f32>,
) -> vec4<f32> {
  var color: vec4<f32> = inColor * getAlbedo();

  if (HAS_COLOR_MAP) {
    color *= getTexture(mapUV.xy);
  }

  return color;
}
